import React, { useEffect, Fragment, useState } from "react";
import { Row, Col } from "reactstrap";
import { MODULE_API } from "../../../apis";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../../../components/styled-components/loader/loader";
import { SelectionSkeleton } from "../../../newComponents/Skeletons/SelectionSkeleton";
import "./subForms/styles/assetsSelect.css";

const AssetAllocation = () => {
  const [data, setData] = useState();
  const [loading, setIsLoading] = useState(true);
  const history = useHistory();

  async function getAllAssets() {
    // setIsLoading(true);
    await MODULE_API.assetAllocation()
      .then((data) => setData(data))
      .catch((error) => console.log("error found", error));
    setIsLoading(false);
  }

  function handleAssetSelect(name) {
    switch (name) {
      case "Inventory":
        history.push("/inventory_new");
        break;

      case "Collectibles":
        // history.push("/inventory_new")
        history.push({
          pathname: `/collectibles_new`,
        });
        // alert("null");
        break;
      // case "Cash/CD's T-Bills":
      //   // history.push("/inventory_new")
      //   // history.push({
      //   //   pathname: `/collectibles_new`,
      //   // });
      //   alert("null");
      //   break;

      default:
        // value(name);
        history.push({
          pathname: `/assets_new/${name}`,
          //   search: name,
          // state: { detail: response.data }
        });
        break;
    }
  }

  useEffect(() => {
    getAllAssets();
  }, []);

  return (
    <Fragment>
      <div className="info-form-block">
        <Row gutter={16}>
          <Col span={24}>
            <h2
              className="text-center font-weight-bold mb-4"
              style={{ fontFamily: "Poppins" }}
            >
              Asset Allocation
            </h2>
          </Col>
        </Row>
      </div>
      <div className="selelctmain">
        <h3 className="selectHeading">Physical</h3>
        {loading && <SelectionSkeleton count={5} />}
        <div className="selectmain" style={{justifyContent:"flex-start"}}>
          {data &&
            data.physical.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  handleAssetSelect(item.name);
                }}
                className="selectMaincards"
              >
                <div className="selectMaincardsInner">
                  {" "}
                  <div className="selectMainImages">
                    <img src={item.image} height={"40px"} alt={item.name} />{" "}
                  </div>
                  <div className="selectMainHeader">
                    <span className="selectheadingValue">{item.name}</span>
                  </div>
                </div>
              </div>
            ))}
        </div>
        <h3 className="selectHeading" style={{ marginTop: "1rem" }}>
          Investment
        </h3>
        {loading && <SelectionSkeleton count={6} />}
        <div className="selectmain" style={{justifyContent:"flex-start"}}>
          {data &&
            data.investment.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  handleAssetSelect(item.name);
                }}
                className="selectMaincards"
              >
                <div className="selectMaincardsInner">
                  {" "}
                  <div className="selectMainImages">
                    <img src={item.image} height={"40px"} alt={item.name} />{" "}
                  </div>
                  <div className="selectMainHeader">
                    <span className="selectheadingValue">{item.name}</span>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
    </Fragment>
  );
};

export default AssetAllocation;
